import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const pageTitleAppearance = cva('', {
  variants: { appearance: { default: '', balanced: 'text-balance' } },
  defaultVariants: { appearance: 'default' },
});

export function PageTitle({
  appearance = 'default',
  className,
  ...props
}: Omit<React.ComponentProps<'h1'>, 'children'> & { children: React.ReactNode } & VariantProps<
    typeof pageTitleAppearance
  >) {
  return (
    <h1
      data-slot="page-title"
      className={cn(
        'min-w-0 max-w-full text-2xl font-semibold tracking-tight text-foreground sm:text-3xl',
        pageTitleAppearance({ appearance }),
        className,
      )}
      {...props}
    />
  );
}

export function StateTitle({
  className,
  ...props
}: Omit<React.ComponentProps<'h1'>, 'children'> & { children: React.ReactNode }) {
  return (
    <h1
      data-slot="state-title"
      className={cn('text-2xl font-semibold tracking-tight', className)}
      {...props}
    />
  );
}
